import {Injectable} from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {Observable} from "rxjs";
import {timeout} from "rxjs/operators";
import {MvsCrudService} from "../../../shared/service/crud/mvs-crud.service";
import {mvsCrudRequestHttpOptions} from "../../../shared/service/crud/mvs-crud-request-options";
import {UiQlWidgetAssistStatusDto} from "../../model/dto/api/ui-ql-widget-assist-status.dto";
import {UiQlWidgetAssistRequestDto} from "../../model/dto/api/ui-ql-widget-assist-request.dto";
import {UiQlWidgetAssistResponseDto} from "../../model/dto/api/ui-ql-widget-assist-response.dto";

/**
 * The two assist endpoints of `UiQlWidgetController` (requirement.md "Erweiterung: LLM-Chat-Designer"
 * L3.3) - the LLM chat designer of the QL workbench. Both require ui-write access (403 otherwise).
 *
 * Every call suppresses the global error toast: the chat renders each failure itself (429, 403,
 * 409, 400 with violations, timeout, network) as a message in the conversation, and a toast on top
 * would report the same failure twice. The error is still thrown to the caller.
 */
@Injectable({
    providedIn: 'root'
})
export class UiQlWidgetAssistService extends MvsCrudService {

    /**
     * Client-side ceiling of one turn. The server aborts hard after 90 s (L3.3); the extra seconds
     * let its own timeout answer arrive first, this one only catches a hanging connection.
     */
    static readonly TURN_TIMEOUT_MS = 95_000;

    constructor(protected override http: HttpClient) {
        super(http, MvsCrudService.baseUrl + '/ui/qlWidgets/assist');
    }

    /** `GET /mvsa/ui/qlWidgets/assist/status` - whether the chat is available on this tenant. */
    public getStatus(): Observable<UiQlWidgetAssistStatusDto> {

        return this.http.get<UiQlWidgetAssistStatusDto>(
            `${this.apiUrl}/status`,
            mvsCrudRequestHttpOptions(true)
        );
    }

    /**
     * `POST /mvsa/ui/qlWidgets/assist` - one synchronous chat turn. Unsubscribing discards the
     * answer ("Abbrechen"); a turn running longer than {@link TURN_TIMEOUT_MS} errors with a
     * `TimeoutError`.
     */
    public assist(request: UiQlWidgetAssistRequestDto): Observable<UiQlWidgetAssistResponseDto> {

        return this.http.post<UiQlWidgetAssistResponseDto>(
            this.apiUrl,
            request,
            mvsCrudRequestHttpOptions(true)
        ).pipe(timeout(UiQlWidgetAssistService.TURN_TIMEOUT_MS));
    }

}
